module.exports = __webpack_public_path__ + "static/img/services-3.df010be.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/services-3.png
// module id = iTmF
// module chunks = 1